// extracted by mini-css-extract-plugin
export default {"badgesList":"BadgeList_badgesList__IV7l7","badge":"BadgeList_badge__0Sh7L"};